import GrnDetail from '../grn/grnDetail';
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { exposedApi } from '../../../services/apiController';
import { toast, ToastContainer } from 'react-toastify';

const JWGrnPrint = () => {
  const formFields = {
    companyId: 1,
    chargeType: '',
    chargeAmount: '',
    grnNumber: '',
    grnDate: '',
    total: '',
    assetsInfo: [],
  };
  let params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [grnForm, setGrnForm] = useState(formFields);

  const getGrnData = () => {
    try {
      setIsLoading(true);
      exposedApi(`/exposed/inv/jw/${params.id}`).then((res) => {
        const Data = res.data;
        setGrnForm(Data);
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  useEffect(() => {
    getGrnData();
  }, []);

  return (
    <>
      <ToastContainer />
      {isLoading ? <Spinner animation="border" variant="info" /> : <GrnDetail data={grnForm} isPrint={true} grnType="JW" />}
    </>
  );
};

export default JWGrnPrint;
